import React, { Fragment } from "react";
import NewUserContent from "../components/users/new-user-content";

const NewUser = () => {
  return <NewUserContent />;
};

export default NewUser;
